import React from 'react';
import gql from 'graphql-tag';
import { injectIntl } from 'react-intl';

import classNames from 'classnames';
import PropTypes from 'prop-types';

import ReviewServiceLogo from '../../components/ReviewServiceLogo';
import StarRating from '../../components/StarRating';
import Truncate from '../../components/Truncate';

import style from './OfficeReview.scss';
import { intlShape } from '../../../shared/shapes';

const OfficeReview = ({ intl, className, review, truncateMessageLength }) => {
  const reviewerName =
    review.reviewer.displayName ||
    intl.formatMessage({ id: 'widgets.OfficeReview.anonymous', defaultMessage: 'Anonymous' });
  return (
    <article className={classNames(style['office-review'], className)}>
      <header className={style['office-review__header']}>
        <figure className={style['office-review__picture']}>
          {review.reviewer.picture ? (
            <img src={review.reviewer.picture} alt={reviewerName} />
          ) : (
            <span>{reviewerName[0]}</span>
          )}
        </figure>
        <div className={style['office-review__header-content']}>
          <h3 className={style['office-review__reviewer-name']}>{reviewerName}</h3>
          <StarRating className={style['office-review__star-rating']} rating={review.rating} />
        </div>
        <ReviewServiceLogo
          className={style['office-review__service-logo']}
          serviceType={review.serviceType}
        />
      </header>
      {review.message && (
        <Truncate
          className={style['office-review__message']}
          text={review.message}
          length={truncateMessageLength}
        />
      )}
    </article>
  );
};

OfficeReview.propTypes = {
  intl: intlShape,
  className: PropTypes.string,
  truncateMessageLength: PropTypes.number,
  review: PropTypes.shape({
    serviceType: PropTypes.string.isRequired,
    rating: PropTypes.number.isRequired,
    message: PropTypes.string,
    reviewer: PropTypes.shape({
      displayName: PropTypes.string,
      picture: PropTypes.string,
    }).isRequired,
  }).isRequired,
};

OfficeReview.defaultProps = {
  truncateMessageLength: 120,
};

const OfficeReviewWithIntl = injectIntl(OfficeReview);

OfficeReviewWithIntl.fragment = {
  name: 'OfficeReview',
  query: gql`
    fragment OfficeReview on PartnerReview {
      id
      serviceType
      rating
      message
      reviewer {
        displayName
        picture
      }
    }
  `,
};

export default OfficeReviewWithIntl;
